const SkipNav = () => {
  return (
    <a className="sr-only sr-only-focusable" href="#content">Skip to main content</a>
  );
};

export {SkipNav};

